<script setup lang="ts">
import merge from 'lodash-es/merge';

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const { $t } = useLocalization();

const props = defineProps<{
    modelValue: any;
    id: number;
}>();

const defaults = ref<any>({
    rows: [{
        tiles: []
    }]
});

const form = computed<FormType<any>>(() =>
{
    return props.modelValue;
});

function triggetModel(): void
{
    emit('update:modelValue', form.value);
}

function addTile(): void
{
    const ids = form.value.settings.rows[props.id].tiles.map((x: { id: any }) => x.id);

    const maxId = form.value.settings.rows[props.id].tiles.length > 0 ? Math.max(...ids) : 1;

    form.value.settings.rows[props.id].tiles.push({
        id: maxId + 1,
        image: null,
        tileTitle: '',
        tileDescription: '',
        tileLink: ''
    });
}

function removeTile(tile: any): void
{
    form.value.settings.rows[props.id].tiles = form.value.settings.rows[props.id].tiles.filter((x: any) => x !== tile);
}

watch(() => props.modelValue, (value: any) =>
{
    triggetModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);

    if (!form.value.settings.rows[props.id].tiles.length)
    {
        form.value.settings.rows[props.id].tiles = [{
            id: 1,
            image: null,
            tileTitle: '',
            tileDescription: '',
            tileLink: ''
        }];
    }
});
</script>

<template>
    <div class="widget-tiles__settings--container">
        <div class="widget-tiles__settings--grid">
            <div v-for="(tile, i) in form.settings.rows[id].tiles" :key="tile.id" class="widget-tiles">
                <IdeoFormGroup :label="$t('[[[Ikona]]]')" :invalid-feedback="form.$errors.first(`image`)" :state="form.$errors.state(`image`)">
                    <IdeoFilePicker v-model="form.settings.rows[id].tiles[i].image" media="images" />
                </IdeoFormGroup>
                <div>
                    <IdeoFormGroup :label="$t('[[[Tytuł kafelka]]]')" :invalid-feedback="form.$errors.first(`tileTitle`)" :state="form.$errors.state(`tileTitle`)" required>
                        <IdeoFormTextarea v-model="form.settings.rows[id].tiles[i].tileTitle" name="tileTitle" />
                    </IdeoFormGroup>
                    <IdeoFormGroup :label="$t('[[[Link]]]')" :invalid-feedback="form.$errors.first(`link`)" :state="form.$errors.state(`link`)">
                        <IdeoFormInput v-model="form.settings.rows[id].tiles[i].tileLink" name="link" />
                    </IdeoFormGroup>
                    <IdeoFormGroup :label="$t('[[[Opis]]]')" :invalid-feedback="form.$errors.first(`tileDescription`)" :state="form.$errors.state(`tileDescription`)">
                        <IdeoFormTextarea v-model="form.settings.rows[id].tiles[i].tileDescription" name="tileDescription" />
                    </IdeoFormGroup>
                    <div class="input-group-append">
                        <ActionButton
                            variant="danger"
                            class="w-100"
                            icon="far fa-trash"
                            :text="$t('[[[Usuń kafelek]]]')"
                            :title="$t('[[[Usuń kafelek]]]')"
                            :confirm="$t('[[[Potwierdzenie usunięcia]]]')"
                            :disabled="form.settings.rows[id].tiles.length < 2"
                            @click="removeTile(tile)"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="widget-tiles__buttons">
        <ActionButton
            variant="light"
            class="w-100"
            icon="far fa-plus"
            :text="$t('[[[Dodaj kafelek]]]')"
            :disabled="form.settings.rows[id].tiles.length >= 3"
            @click="addTile()"
        />
    </div>
</template>

<style lang="scss">
.widget-tiles {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;
    border: 1px solid #eee;
    padding: 8px;
    box-shadow: 0 0 5px #efefef;
}
.widget-tiles__buttons {
    box-shadow: none;
    border-width: 0;
}
.widget-tiles__settings--container {
    container-type: inline-size;
    display: flex;
    gap: 20px;
}

.widget-tiles__settings--grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 20px;
    margin-bottom: 1rem;

    @container (min-width: 400px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @container (min-width: 754px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}
</style>
